<template>
  <basicContainer>
    <authSourceTop @rowClick="rowClick"></authSourceTop>
     <el-tabs   @tab-click="choose" v-model="activeName" type="card" >
        <el-tab-pane label="字段授权" name="ZDSQ">
          <authField :resourceId='resourceId' ref="authField"></authField>
        </el-tab-pane>
        <el-tab-pane  label="过滤条件映射" name="GLTJYS"  >
          <conditionsMapping :resourceId='resourceId' ref="conditionsMapping"></conditionsMapping>
        </el-tab-pane>
      </el-tabs>
  </basicContainer>
</template>

<script>

import authSourceTop from './authSourceInner/authSourceTop'
import authField from './authSourceInner/authField'
import conditionsMapping from './authSourceInner/conditionsMapping'
export default {
  data() {
    return {
      activeName: 'ZDSQ',
      resourceId: ''
    }
  },

  components: { authSourceTop, authField, conditionsMapping },

  methods: {
    // 主表点击事件
    rowClick(row) {
      this.resourceId = row.id
      this.$nextTick(() => {
        if (this.activeName === 'ZDSQ') {
          if (this.$refs.authField) { this.$refs.authField.onLoad() }
        } else {
          if (this.$refs.conditionsMapping) { this.$refs.conditionsMapping.onLoad() }
        }
      })
    },
    choose(component) {
      if (component.name === 'ZDSQ') {
        if (this.$refs.authField) { this.$refs.authField.onLoad() }
      } else {
        if (this.$refs.conditionsMapping) { this.$refs.conditionsMapping.onLoad() }
      }
    }
  }
}

</script>
<style lang='scss' scoped>

</style>
